var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#B9ACD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10336_28659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6875 12H14.8125C14.8125 10.4475 13.5525 9.1875 12 9.1875V10.3125C12.9338 10.3125 13.6875 11.0662 13.6875 12ZM15.9375 12H17.0625C17.0625 9.20438 14.7956 6.9375 12 6.9375V8.0625C14.1769 8.0625 15.9375 9.82313 15.9375 12ZM16.5 13.9688C15.7969 13.9688 15.1219 13.8563 14.4919 13.6481C14.4356 13.6313 14.3738 13.62 14.3175 13.62C14.1713 13.62 14.0306 13.6762 13.9181 13.7831L12.6806 15.0206C11.0887 14.2106 9.78375 12.9112 8.97375 11.3137L10.2112 10.0706C10.3687 9.92437 10.4137 9.705 10.3519 9.50813C10.1437 8.87813 10.0312 8.20312 10.0312 7.5C10.0312 7.19062 9.77813 6.9375 9.46875 6.9375H7.5C7.19062 6.9375 6.9375 7.19062 6.9375 7.5C6.9375 12.7819 11.2181 17.0625 16.5 17.0625C16.8094 17.0625 17.0625 16.8094 17.0625 16.5V14.5312C17.0625 14.2219 16.8094 13.9688 16.5 13.9688ZM8.07938 8.0625H8.92313C8.9625 8.5575 9.04688 9.04688 9.17625 9.51375L8.50125 10.1944C8.27625 9.51375 8.13 8.805 8.07938 8.0625ZM15.9375 15.9206C15.195 15.87 14.475 15.7237 13.8 15.4931L14.475 14.8181C14.9531 14.9531 15.4425 15.0375 15.9375 15.0712V15.9206Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10336_28659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(5.25 5.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.194f067eabc3351b33124bf8278bf47e.svg";
export { ForwardRef as ReactComponent };